import React, { useState } from 'react';
import { mapDivEnterToClick, setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

const FloatingMessagesUI = (props: UIProperties<FloatingMessagesUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	return (
		<div className="modal-disable-select" tabIndex={0} id='auscultate-top' aria-label=''>
			{props.parameters.messages.map((message: FloatingMessagesUIMessageConfig, indx: number) => {
				if(!message.timeout && message.showMessage) {
					setFocus('floating-message-' + indx);
					message.timeout = setTimeout(() => {
						message.hideHotspot = true;
						message.onDismissed();
						setForceUpdate(!forceUpdate);
					}, 3000);
				}
				
				return !message.hideHotspot ? (
					<div>
						{message.showMessage ? (<div style={{
							position: 'absolute',
							top: message.top,
							left: message.left,
							width: '300px',
							height: '152px'
						}}>
							<img style={{
								width: '100%',
								height: '100%'
							}} src="./assets/images/general/window_modal_2.png" />
							<p tabIndex={0} style={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
								fontSize: '12pt',
								margin: '0',
								width: '100%',
								textAlign: 'center'
							}} className='title-font' id={'floating-message-' + indx}>{message.title}</p>
						</div>): (
							<div style={{
								position: 'absolute',
								top: message.top,
								left: message.left,
								width: '450px',
								height: '350px',
								backgroundColor: props.parameters.isDebug ? 'transparent' : 'transparent',
								pointerEvents: 'all'
							}} tabIndex={0} aria-label={message.title.split(':')[0]} role='button' onMouseOver={() => {
								message.showMessage = true; 
								setForceUpdate(!forceUpdate);
							}} onKeyUp={mapDivEnterToClick} onClick={() => {
								message.showMessage = true; 
								setForceUpdate(!forceUpdate);
							}}>

							</div>
						)}
					</div>) : (null);
			})}
		</div>
	);
};

export interface FloatingMessagesUIConfig extends BaseConfig{
	messages: FloatingMessagesUIMessageConfig[];
	isDebug: boolean;
}

export interface FloatingMessagesUIMessageConfig extends BaseConfig{
	title: string;
	top: string;
	left: string;
	hideHotspot?: boolean;
	showMessage?: boolean;
	timeout?: any;
	onDismissed?: () => void;
}

export default FloatingMessagesUI;